import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHHorarioDel = async (credentials, data) => {
  const body = {
    service: "RNHHorarioDel",
    params: {
      rnhHorarioId: data?.id ?? null,
      rnhHorarioVersion: data?.version ?? null,
    },
  };
  return respuestaDe(await axiosPost(body, credentials));
};

